import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=713a1b9e&v-on-clickaway=cancel&"
import script from "./Update.vue?vue&type=script&lang=ts&"
export * from "./Update.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports